<template>
  <div class="serve">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>
    <div class="banner">
      <div
        style="width: 1200px; height: 100%; position: relative; margin: 0 auto"
      >
        <div class="upload-btn" style="" @click="toUpload">
          <img src="../../static/server/whiteupload.png" alt="" />
          <span></span>
          上传服务
        </div>
        <h2>服务</h2>
        <div class="banner-liner"></div>
        <p>Service</p>
      </div>
    </div>
    <!-- 内容 -->
    <div class="bussinessServe" v-for="(item, index) in list" :key="index">
      <div class="businessBatten">
        <div class="blueLine"></div>
        <div class="businessCH">{{ item.catalogueName }}</div>
        <!-- <div class="businessEN">{{ item.catalogueEnglishName }}</div> -->
        <button
          class="moreBtn"
          @click="
            toMore(
              item.catalogueId,
              item.catalogueName,
              item.catalogueEnglishName
            )
          "
        >
          更多 >>
        </button>
      </div>
      <div class="businessList">
        <ul class="businessUl">
          <li
            v-for="(itemSubset, index) in item.servicesModels"
            :key="index"
            @click="
              toDetail(
                itemSubset.servicesId,
                item.catalogueId,
                item.catalogueName
              )
            "
          >
            <div style="width:285px;height:200px;overflow:hidden">
              <img class="hover" :src="itemSubset.coverImg" alt="" />
            </div>
            <div class="text">
              <div class="text-b">{{ itemSubset.servicesName }}</div>
              <div class="text-s">{{ itemSubset.baseRemark }}</div>
            </div>
            <button
              class="detailBtn"
              @click="
                toDetail(
                  itemSubset.servicesId,
                  item.catalogueId,
                  item.catalogueName
                )
              "
            >
              查看详情
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from "@/components/common/navigation";

export default {
  name: "serve",
  components: {
    navigation,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    //服务
    this.$axios
      .get("/v1/cloud/common/services", {})
      .then(({ data }) => {
        this.list = data;
        // if(data){
        //     data.forEach(function(item,index){
        //        item.servicesModels.forEach((item,index)=>{
        //            item.remark = item.remark.substr(0,34) + '...' ;
        //        })
        //     })
        //     console.log(22)
        //     this.list = data;
        //     console.log(this.list)
        // }
      })
      .catch((error) => {
        //this.$message.error(error.response.data.message);
      });
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    //锚点
    let name = this.$route.query.name;
    if (name === "gs") {
      document.documentElement.scrollTop = document.body.scrollTop = 500;
    } else if (name === "jr") {
      document.documentElement.scrollTop = document.body.scrollTop = 1000;
    } else if (name === "fl") {
      document.documentElement.scrollTop = document.body.scrollTop = 1500;
    } else if (name === "jy") {
      document.documentElement.scrollTop = document.body.scrollTop = 2000;
    }
  },
  methods: {
    toUpload() {
      this.$axios
        .get("/v1/cloud/user/validator/service-provider", {})
        .then(({ data }) => {
          if (data) {
            this.$router.push("/serve-upload");
          }
        })
        .catch((error) => {
          var err = error.response;
          if (err.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (err.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },
    toMore(id, catalogueName, catalogueEnglishName) {
      this.$router.push({
        path: "/serveList",
        query: {
          id,
          catalogueName,
          catalogueEnglishName,
        },
      });
    },
    toDetail(servicesId, catalogueId, catalogueName) {
      this.$router.push({
        path: "/serveDetail",
        query: {
          servicesId,
          catalogueId,
          catalogueName,
        },
      });
    },
    toServeList() {
      this.$router.push("/serveList");
    },
    toServeDetail() {
      this.$router.push("/serveDetail");
    },
  },
};
</script>

<style scoped lang="less">
img.hover {
  transition: all 1s
}
img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}
.serve {
  width: 100%;
  background-color: #f5f5f5;
  padding-bottom: 50px;
  .banner {
    width: 100%;
    height: 500px;
    background: url(../../static/server/banner.png);
    background-size: 100% 100%;
    background-position: center;
    margin-bottom: 30px;
    position: relative;
    .upload-btn {
      width: 150px;
      height: 50px;
      position: absolute;
      left: 40px;
      top: 50px;
      line-height: 50px;
      border-radius: 20px;
      cursor: pointer;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background-color: #3476c1;
      border-radius: 5px;
      background-image: linear-gradient(#61aafe, #3476c1);
      text-indent: 57px;
      img {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 17px;
        left: 31px;
      }
    }
    h2 {
      font-size: 65px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 60px;
      position: absolute;
      right: 100px;
      top: 100px;
    }
    .banner-liner {
      width: 80px;
      height: 2px;
      background: #ffffff;
      position: absolute;
      top: 191px;
      right: 146px;
    }
    p {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 19px;
      position: absolute;
      top: 223px;
      right: 146px;
    }
  }
  .bussinessServe {
    width: 1200px;
    height: 450px;
    margin: 0px auto;
    text-align: center;
    .businessBatten {
      height: 40px;
      position: relative;
      .blueLine {
        width: 4px;
        height: 26px;
        background: #3476C1;
        float: left;
        margin-top: 7px;
      }
      .businessCH {
        float: left;
        // width:78px;
        // height:19px;
        line-height: 40px;
        font-size: 26px;
        font-family: MicrosoftYaHei;
        font-weight: 500;
        color: #111111;
        margin-left: 20px;
      }
      .businessEN {
        // width:199px;
        // height:18px;
        font-size: 24px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(101, 101, 101, 1);
        float: left;
        margin-left: 20px;
        line-height: 40px;
      }
      .moreBtn {
        float: right;
        padding-right: 10px;
        // height: 14px;
        line-height: 40px;
        outline: none;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #666666;
        border: none;
        background-color: #f5f5f5;
        vertical-align: middle;
        // position: absolute;
        // right: 20px;
        // top: 40px;
      }
      .moreBtn:hover {
        color: #5fc0e4;
      }
    }
    .businessList {
      height: 430px;
      margin-top: 30px;
      .businessUl {
        list-style-type: none;
        display: flex;
        justify-content: space-between;
        li {
          width: 285px;
          height: 342px;
          position: relative;
          cursor: pointer;
          background-color: #fff;
          transition: 0.2s all;
          img {
            display: block;
            width: 285px;
            height: 200px;
          }
          .text {
            padding-left: 10px;
            padding-top: 20px;
            text-align: left;
            .text-b {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 10px;
            }
            .text-s {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #888888;
              line-height: 25px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          }
          .detailBtn {
            width: 120px;
            height: 30px;
            border: 1px solid #5fc0e4;
            border-radius: 3px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #5fc0e4;
            line-height: 30px;
            background-color: #fff;
            position: absolute;
            top: 315px;
            left: 83px;
            display: none;
          }
          .detailBtn:hover {
              background-color: #5FC0E4;
              color: #fff;
          }
        }
        li:hover {
            height: 365px;
          .detailBtn {
              display: block;
          }

        }
        li:nth-of-type(3) {
          margin-right: 0;
        }
        .lastLi {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
